import {
  AuthBackToSignInFooter,
  AuthEmptyHeader,
  AuthSignInFooter,
  ConfirmResetPasswordHeading,
  ConfirmSignUpHeading,
  ResetPasswordHeading,
  SignInHeading,
  SignUpHeading
} from './AuthAuthenticatorComponents';

/** Amplify Authenticator component overrides — keep config separate from components for Fast Refresh. */
export const authComponents = {
  Header: AuthEmptyHeader,
  SignIn: {
    Header: SignInHeading,
    Footer: AuthSignInFooter
  },
  SignUp: {
    Header: SignUpHeading,
    Footer: AuthSignInFooter
  },
  ForgotPassword: {
    Header: ResetPasswordHeading,
    Footer: AuthBackToSignInFooter
  },
  ConfirmSignUp: {
    Header: ConfirmSignUpHeading
  },
  ConfirmResetPassword: {
    Header: ConfirmResetPasswordHeading,
    Footer: AuthBackToSignInFooter
  }
};
